import _ from 'lodash';
import { SettingValues } from 'common/services/settings.service';
import { useSelector } from 'react-redux';
import { pmSensorAuthIdSelector } from 'state/selectors/sensors-authorizations';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import useSettingsService from 'components/hooks/useSettingsService';
import { getAdditionalTypesFlatten } from '../../SettingsModal/InputsSetting/AdditionalTypesSelector/additional-types.utils';
import { RA_ADDITIONAL_TYPES } from '../../../resource_types';

const useRaInputsSetting = () => {
  const pmSensorAuthId = useSelector(pmSensorAuthIdSelector);
  const { updateSetting, getSettingOrDefinitionValue } = useSettingsService();
  const value = getSettingOrDefinitionValue({
    name: SettingValues.RA_INPUTS
  });
  const excludedTypes = _.get(value, 'excluded_types', []);
  const additionalTypes = _.get(value, 'additional_types', []);

  const onSave = async ({ excluded_types = [], additional_types = [] }) => {
    const isAdditionalTypesModified = !_.isEqual(
      additionalTypes,
      additional_types
    );

    const settingPayload = {
      excluded_types,
      additional_types,
      sensor_authorization_id: pmSensorAuthId
    };
    if (isAdditionalTypesModified) {
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.RESOURCE_ALLOCATION,
        click_type: TRACKING.CLICK.RESOURCE_ALLOCATION.SETTINGS.CUSTOM_FIELDS,
        value: !!additional_types?.length
      });
    }

    await updateSetting(SettingValues.RA_INPUTS, settingPayload);
  };

  const getLabelsFlatten = () =>
    getAdditionalTypesFlatten(additionalTypes)
      .filter(({ type }) => type === RA_ADDITIONAL_TYPES.LABEL)
      .map(label => label?.id)
      .filter(Boolean);

  return {
    value,
    excludedTypes,
    additionalTypes,
    getLabelsFlatten,
    onSave
  };
};

export default useRaInputsSetting;
